import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs, setDoc, doc }
    from "firebase/firestore";

import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdApps, MdClose, MdEdit, MdEditNote, MdPrint } from "react-icons/md";
import { Randomcode } from "../../components_root/rendom_code.js";
import { Save_log_history } from "../../log_history_root/save_log_history.js";
export default function Printsetting_master() {
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const [printdata, setPrintdata] = useState([]);
    const { Toastshow } = Toast();
    const [printsize, setPrintsize] = useState("4INCH");
    
    // ---------- Live vouchers load ----------
    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        setIsLoading2(true);

        if (!select_company_uid) {
            console.error("No company selected");
            setIsLoading2(false);
            return;
        }

        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "print_setting")
        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => {
                    const d = docSnap.data();

                    // Convert indexed array → object
                    const settingObj = {};
                    (d.settingdata || [])
                        .sort((a, b) => a.index - b.index)
                        .forEach(item => {
                            settingObj[item.key] = item.value;
                        });

                    return {
                        id: docSnap.id,
                        ...d,
                        settingdata: settingObj   // <-- your JSX uses this
                    };
                });

                setPrintdata(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching :", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, []);

    //
    const [print_name, setPrint_name] = useState("");
    const [print_title, setPrint_title] = useState("");
    const [print_tagline, setPrint_tagline] = useState("");
    const [print_contactinfo, setPrint_contactinfo] = useState("");
    const [print_address, setPrint_address] = useState("");
    const [print_address_footer, setPrint_address_footer] = useState("");
    const [print_contact_info_footer, setPrint_contact_info_footer] = useState("");
       const [print_trams_footer, setPrint_terms_footer] = useState("Payment received. For any query, please contact us.");
    const set_print_setting = async () => {
        if (!print_name || !print_name.trim()) {
            Toastshow("Please enter print name");
            return;
        }
        if (!print_title || !print_title.trim()) {
            Toastshow("Please enter print title");
            return;
        }

        const servicetablename = "accountingfinancedb";
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");

        if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
        if (!guid) return { success: false, error: "Login expired. Please relogin." };
        if (!select_company_uid) return { success: false, error: "Contact service provider." };

        const collectionval = collection(
            db,
            servicetablename,
            select_company_uid,
            "print_setting"
        );

        // Check duplicate
        const duplicateQuery = query(
            collectionval,
            where("print_name", "==", print_name)
        );

        const duplicateSnap = await getDocs(duplicateQuery);

        if (!duplicateSnap.empty) {
            Toastshow("Print name is duplicate");
            return;
        }

        let printid = Randomcode(10);

        // raw data
        const settingdataRaw = {
            print_title,
            print_tagline,
            print_contactinfo,
            print_address,
            print_trams_footer,
            print_address_footer,
            print_contact_info_footer
        };

        // remove empty
        const cleaned = Object.fromEntries(
            Object.entries(settingdataRaw).filter(
                ([_, v]) => v !== null && v !== undefined && v !== ""
            )
        );

        // convert into indexed array
        const indexed = Object.entries(cleaned).map(([key, value], index) => ({
            index,
            key,
            value
        }));

        // save payload
        const payload = {
            print_name,
            printsize,
            settingdata: indexed,    // <-- stored as index array
            printid,
            guid,
            status: false,
            companyuid: select_company_uid,
            date_time: new Date(),
            date_time_update: new Date()
        };

        const ref = doc(
            db,
            servicetablename,
            select_company_uid,
            "print_setting",
            printid
        );

        await setDoc(ref, payload, { merge: true });

        // Toastshow("Saved Successfully");
        handle_Create(printid);
    };
       const handle_Create = async (docid) => {
            const logid = Randomcode(25);
            if (!print_name || !print_name.trim()) {
                Toastshow("Please print name");
                return;
            }
            const settingdataRaw = {
                print_title,
                print_tagline,
                print_contactinfo,
                print_address,
                print_address_footer,
                print_contact_info_footer,
                print_trams_footer
            };
            // remove empty 
            const dataupdates = {
                log_id: logid,
                // 
                ...settingdataRaw,
                status: true,
                // Add other necessary fields here
            };
            create_log(logid, dataupdates, docid, "print_setting", print_name, printsize);
        };
        const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {
    
            const log_description = "account_type:" + account_type + ", " + description;
            const log_data = {
                logid,
                history_type: "authority",
                servicetablename: "accountingfinancedb",
                tablename: "print_setting",
                filedname: "printid",
                filedid: filedid,
                log_description,
                log_status: false,
                verify_status: false,
                verify_note,
                //change info            
                dataupdates,
               // accountguid,
                description: description,
                account_type: account_type,
            };
            const result = await Save_log_history(log_data);
            if (result.success) {
                //  navigate(-1);
                Toastshow("Saved successfully.");
    
            } else {
                Toastshow(result.error || "Failed to save voucher.");
            }
        };
const openEdit = (uid) => {
    navigate(`/accounting?page=printsetting_edit&uid=${uid}`, {
        state: {printid: uid }
    });
};
    return (
        <div>
            <div className="post-container p-2">
                  <div className="post_updates">
                                   <div className="ui-items p-11 items-back items-back shadow">
                                       <table>
                                           <tr>
                                               <td>
                                                   <table className="table-fixed">
                                                       <tr>
                                                           <td  >
                                                               <div
                                                                   onClick={() => setPrintsize("4INCH")}
                                                                   className={`fill bold  p-2 cursor ${printsize === "4INCH" ? "button-ui green-back" : "button-ui2"}`}
                                                               >
                                                                   <MdPrint className="icon" />
                                                                   4 Inch
                                                               </div>
                                                           </td>
               
                                                           <td  >
                                                               <div
                                                                   onClick={() => setPrintsize("A4")}
                                                                   className={`fill  p-2 cursor ${printsize === "A4" ? "button-ui red-back" : "button-ui2"}`}
                                                               >
                                                                   <MdPrint className="icon" />
                                                                   A4
                                                               </div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                                   <div className="text-h3 text-off">
                                                       {printsize === "4INCH" ? "4 inch: 100–110 mm (common for shipping labels)" :
                                                           "A4 210 × 297 mm, Standard office paper used worldwide for letters, forms, printouts, and documents."}
                                                   </div>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <input value={print_name} onChange={(e) => setPrint_name(e.target.value)} maxLength={30} placeholder="Print name for vocher" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h2 bold">
                                                   Print Header
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Title Company name*
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_title.length - 30}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <input className="bold text-h1" value={print_title} onChange={(e) => setPrint_title(e.target.value)} maxLength={30} placeholder="Print title" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Tag line / Reg. Number option
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_tagline.length - 30}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
               
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <input className="text-h2"
                                                       value={print_tagline} onChange={(e) => setPrint_tagline(e.target.value)}
                                                       maxLength={30} placeholder="Print Tag line / Reg. Number" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
               
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Contact info option
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_contactinfo.length - 30}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <input className="text-h2" maxLength={30}
                                                       value={print_contactinfo} onChange={(e) => setPrint_contactinfo(e.target.value)}
                                                       placeholder="Print contact info option" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
               
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Address
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_address.length - 100}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <textarea className="text-h2"
                                                       value={print_address} onChange={(e) => setPrint_address(e.target.value)}
                                                       maxLength={50} placeholder="Print address option" />
                                               </td>
                                           </tr>
               
                                           <br />
                                           <tr >
                                               <td className="text-h2 bold">
                                                   Print Footer   option
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
               
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Terms and conditions
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_trams_footer.length - 100}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <textarea className="text-h2" maxLength={100}
                                                       value={print_trams_footer} onChange={(e) => setPrint_terms_footer(e.target.value)}
                                                       placeholder="Print contact info option" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
               
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Contact info
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_contact_info_footer.length - 50}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
                                           </tr>
                                           <tr>
                                               <td>
                                                   <input className="text-h2" maxLength={50}
                                                       value={print_contact_info_footer} onChange={(e) => setPrint_contact_info_footer(e.target.value)}
                                                       placeholder="Print contact info option" />
                                               </td>
                                           </tr>
                                           <tr>
                                               <td className="text-h3 text-off">
               
                                                   <table>
                                                       <tr>
                                                           <td>
                                                               Address
                                                           </td>
                                                           <td width={30}>
                                                               <div className="text-r bold">{print_address_footer.length - 50}</div>
                                                           </td>
                                                       </tr>
                                                   </table>
                                               </td>
               
                                           </tr>
                                           <tr>
                                               <td>
                                                   <textarea className="text-h2"
                                                       value={print_address_footer} onChange={(e) => setPrint_address_footer(e.target.value)}
                                                       maxLength={50} placeholder="Print address option" />
                                               </td>
                                           </tr>
               
               
               
                                       </table>
                                       <div onClick={() => set_print_setting()} className="button-ui cursor text-h2 bold fill p-2"><MdPrint className="icon" /> Save</div>
                                   </div>
                               </div>
                <div className="post_div">
                    <div className="ui-grid-home-items">



                        {IsLoading2 ? (
                            <></>
                        ) : printdata.length === 0 ? (
                            <div className="text-h2 bold p-5">No Print Found</div>
                        ) : (
                            printdata.map((row) => (
                                <div
                                    className="ui-items p-11 items-back items-back shadow hover rounded cursor"
onClick={()=>openEdit(row.printid)}
                                    key={row.accountguid}
                                >
                                    <table >
                                        <tr className="b-bootom p-11">
                                            <td  > <div
                                                className="bold"
                                                style={{ color: row.status === true ? "green" : "red" }}
                                            >
                                                {row.status === true ? "Activate" : "Deactivate"}
                                            </div></td>
                                            <td width={130} className='text-h3 text-r '>
                                                {row.date_time?.toDate ? (
                                                    <>
                                                        {row.date_time_update.toDate().toLocaleDateString()}{" "}
                                                        {row.date_time_update.toDate().toLocaleTimeString()}
                                                    </>
                                                ) : (
                                                    <div className='contact-details'>No date</div>
                                                )}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">
                                                Print Name
                                            </td>
                                            <td>
                                                <div className="text-h2 bold">{row.print_name}</div>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">
                                                Print Size
                                            </td>
                                            <td>
                                                <div className="text-h2 bold">{row.printsize}</div>

                                            </td>
                                        </tr>
                                    </table>
                                    <div className="b-dot-2-red rounded m-1" >

                                        <table className="table_padding">

                                            <tbody>
                                                {Object.entries(row.settingdata || {}).map(([key, value]) => (
                                                    <>
                                                        <tr key={key}>
                                                            <td className="text-h3 text-off fcap">{key.replaceAll("_", " ")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-h3 bold fcap">{String(value)}</td>
                                                        </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>

                                    </div>

                                    <div className="button-ui3 p-11 red cursor fill ">Delete</div>
                                </div>
                            ))
                        )}

                    </div>
                </div>
            </div>


        </div>
    );
}